// file: src/KalkulatorDoprinosiNKG.js

import React, { useState, useEffect } from 'react';
import './Kalkulator.css';
import { FaLeaf } from 'react-icons/fa'; // ikona za "nekomercijalno" (simbolično)

function KalkulatorDoprinosiNKG() {
  // Sve podržane godine (isto kao u mapiranju u backendu)
  const godine = [2026, 2025, 2024, 2023, 2022, 2021, 2020, 2019, 2018];

  const [godina, setGodina] = useState(2025);
  const [rezultati, setRezultati] = useState(null);
  const [loading, setLoading] = useState(false);
  const [submitError, setSubmitError] = useState(null);

  // Kad se promijeni odabrana godina, automatski pozivamo backend
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      setRezultati(null);
      setSubmitError(null);

      try {
        const res = await fetch('https://plata--kalkulator-backend-api--gklzkvjpw2s5.code.run/doprinosi-nkg/', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ godina: godina })
        });
        if (!res.ok) {
          const errData = await res.json();
          throw new Error(errData.detail || 'Greška pri dohvaćanju.');
        }
        const data = await res.json();
        setRezultati(data);
      } catch (err) {
        setSubmitError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [godina]);

  // Promjena u selectu
  const handleChange = (e) => {
    setGodina(parseInt(e.target.value, 10));
  };

  return (
    <>
      {/* Naslov aplikacije */}
      <header className="app-header">
        <h1>
          NEKOMERCIJALNO GAZDINSTVO <br />
          <br />
          (Doprinosi za nekomercijalno gazdinstvo)
        </h1>
      </header>

    <div className="container">
      {/* Lijeva kartica: izbor godine */}
      <div className="form-container card">
        <div className="form-header">
          <h2>
            Izbor podataka
          </h2>
        </div>

        <div className="field-group">
          <label htmlFor="godina" className="field-label">
            Izaberite godinu<span className="required">*</span>:
          </label>
          <select
            id="godina"
            className="field-select"
            value={godina}
            onChange={handleChange}
          >
            {godine.map((g) => (
              <option key={g} value={g}>
                {g}
              </option>
            ))}
          </select>
        </div>
      </div>

      {/* Desna kartica: prikaz rezultata */}
      <div className="results-container card">
        {loading && (
          <div className="section-title">Računam…</div>
        )}
        {submitError && (
          <div className="error-text">{submitError}</div>
        )}
        {rezultati && (
          <>
            <h3 className="section-title">Rezultati za {godina}</h3>
            <div className="results-section">
              <div className="result-row">
                <span>Prosječna bruto plata:</span>
                <span>{rezultati.prosjecna_bruto.toFixed(2)}</span>
              </div>
              <div className="result-row">
                <span>Osnovica (20%):</span>
                <span>{rezultati.osnovica.toFixed(2)}</span>
              </div>
              <div className="result-row">
                <span>Mjesečni doprinos za zdravstvo:</span>
                <span>{rezultati.mjesecni_doprinos.toFixed(2)}</span>
              </div>
              <div className="result-row">
                <span>Godišnji trošak:</span>
                <span>{rezultati.godisnji_trosak.toFixed(2)}</span>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
    </>
  );
}

export default KalkulatorDoprinosiNKG;
